import { Routes } from '@angular/router';

import { PublicGuard } from '../core/guards/public.guard';
import { RegisterWrapperComponent } from '../pages/register-wrapper/register-wrapper.component';
import { RegisterMovelComponent } from '../pages/register-movel/register-movel.component';
import { SelectFixaContractComponent } from '../pages/select-fixa-contract/select-fixa-contract.component';
import { ForgotPasswordComponent } from '../pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '../pages/reset-password/reset-password.component';
import { SuccessRegisterComponent } from '../pages/success-register/success-register.component';
import { ConfirmEmailComponent } from '../pages/confirm-email/confirm-email.component';
import { LoginComponent } from '../pages/login/login.component';
import { AuthGuard } from '../core/guards/auth.guard';
import { ExternalChannelCompleteAddressGuard } from '../core/guards/external-channel-complete-address.guard';
import { ExternalChannelCompleteAddressLeaveGuard } from '../core/guards/external-channel-complete-address-leave.guard';
import { ExternalChannelAccessComponent } from '../pages/external-channel-access/external-channel-access.component';
import { ExternalChannelCompleteAddressComponent } from '../pages/external-channel-complete-address/external-channel-complete-address.component';
import { SegmentSelectionComponent } from '../pages/segment-selection/segment-selection.component';

export const authRoutes: Routes = [
  {
    path: 'login/cnpj/:authPayload',
    component: ExternalChannelAccessComponent,
  },
  {
    path: 'segment-selection',
    component: SegmentSelectionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'external-channel-complete-address',
    component: ExternalChannelCompleteAddressComponent,
    canActivate: [ExternalChannelCompleteAddressGuard],
    canDeactivate: [ExternalChannelCompleteAddressLeaveGuard],
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [PublicGuard],
  },
  {
    path: 'register',
    component: RegisterWrapperComponent,
  },
  {
    path: 'register-movel',
    component: RegisterMovelComponent,
  },
  {
    path: 'select-fixa-contract',
    component: SelectFixaContractComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [PublicGuard],
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [PublicGuard],
  },
  {
    path: 'success-register',
    component: SuccessRegisterComponent,
  },
  {
    path: 'confirm-email',
    component: ConfirmEmailComponent,
  },
];
